import React, { useRef } from 'react';
import { AlertCircle, Loader2, LogOut } from 'lucide-react';
import { useModalAccessibility } from '../hooks/useModalAccessibility';

interface Props {
  pending: boolean;
  error: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

const LogoutConfirmationDialog: React.FC<Props> = ({ pending, error, onCancel, onConfirm }) => {
  const dialogRef = useRef<HTMLDivElement>(null);
  const cancelRef = useRef<HTMLButtonElement>(null);
  useModalAccessibility(dialogRef, { onClose: pending ? undefined : onCancel, initialFocusRef: cancelRef });

  return (
    <div className="fixed inset-0 z-[90] flex items-end justify-center bg-canvas/85 p-4 backdrop-blur-sm sm:items-center" onMouseDown={() => { if (!pending) onCancel(); }}>
      <div ref={dialogRef} role="alertdialog" aria-modal="true" aria-labelledby="logout-title" aria-describedby="logout-description" tabIndex={-1} onMouseDown={(event) => event.stopPropagation()} className="w-full max-w-sm rounded-[1.75rem] border border-line/70 bg-panel p-6 shadow-2xl motion-micro-scale">
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-raised text-juris"><LogOut size={22} aria-hidden="true" /></div>
        <h2 id="logout-title" className="text-xl font-extrabold text-ink">Cerrar sesión</h2>
        <p id="logout-description" className="mt-2 text-sm leading-relaxed text-muted">¿Quieres cerrar tu sesión en Juris?</p>
        {error && <p role="alert" className="mt-4 flex gap-2 text-sm text-danger"><AlertCircle size={18} className="shrink-0" aria-hidden="true" />{error}</p>}
        <div className="mt-6 flex gap-3">
          <button ref={cancelRef} type="button" onClick={onCancel} disabled={pending} className="min-h-11 flex-1 rounded-xl bg-raised px-4 font-bold text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-juris disabled:opacity-50">Cancelar</button>
          <button type="button" onClick={onConfirm} disabled={pending} className="inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-xl bg-action px-4 font-bold text-white hover:bg-action-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-juris disabled:opacity-60">{pending ? <><Loader2 size={17} className="animate-spin" aria-hidden="true" /> Cerrando…</> : 'Cerrar sesión'}</button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmationDialog;
